// Botón para mostrar/ocultar la contraseña en el login.
const mountPasswordToggles = () => {
  document.querySelectorAll('[data-password-toggle]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    const button = wrapper.querySelector('[data-password-toggle-button]');
    if (!input || !button || button.dataset.bound) return;

    button.dataset.bound = 'true';
    button.addEventListener('click', () => {
      const visible = input.type === 'password';
      input.type = visible ? 'text' : 'password';
      button.setAttribute('aria-pressed', String(visible));
      button.setAttribute('aria-label', visible ? 'Ocultar contraseña' : 'Mostrar contraseña');
      input.focus();
    });
  });
};

document.addEventListener('turbo:load', mountPasswordToggles);
